export default __webpack_public_path__ + "images/969efac7e78b43bf972abfd43d4a11d2-kayaking_small.webp";